import { Component, OnInit } from '@angular/core';
import { faStroopwafel } from '@fortawesome/free-solid-svg-icons'

@Component({
  selector: 'app-loading-screen',
  templateUrl: './loading-screen.component.html',
  styleUrls: ['./loading-screen.component.css']
})
export class LoadingScreenComponent implements OnInit {

  public faStroopwafel = faStroopwafel

  constructor() { }

  ngOnInit(): void {
  }

}
